import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  greeting: {
    id: 'dashboard.greeting',
    defaultMessage: 'Welcome Back,',
    description: 'Dashboard greeting shown to an actively-learning learner (State C)',
  },
  greetingStart: {
    id: 'dashboard.greetingStart',
    defaultMessage: 'Start Learning,',
    description: 'Dashboard greeting shown to a pre-engagement learner (States A and B)',
  },
  fallbackCourseTitle: {
    id: 'dashboard.fallbackCourseTitle',
    defaultMessage: 'Course',
    description: 'Fallback title shown on an ongoing course card when no course name is available',
  },
  courseBadge: {
    id: 'dashboard.courseBadge',
    defaultMessage: 'Course',
    description: 'Badge label shown on an ongoing course card',
  },
  activityVideo: {
    id: 'dashboard.activityType.video',
    defaultMessage: 'Video',
    description: 'Resume-hero badge when the last accessed unit is a video',
  },
  activityProblem: {
    id: 'dashboard.activityType.problem',
    defaultMessage: 'Problem',
    description: 'Resume-hero badge when the last accessed unit is a problem',
  },
  activityReading: {
    id: 'dashboard.activityType.reading',
    defaultMessage: 'Reading',
    description: 'Resume-hero badge when the last accessed unit is HTML/text content',
  },
  activityDiscussion: {
    id: 'dashboard.activityType.discussion',
    defaultMessage: 'Discussion',
    description: 'Resume-hero badge when the last accessed unit is a discussion',
  },
  activityAssessment: {
    id: 'dashboard.activityType.assessment',
    defaultMessage: 'Assessment',
    description: 'Resume-hero badge when the last accessed unit is an open-response assessment',
  },
  aiQueryPlaceholder: {
    id: 'dashboard.aiQueryBar.placeholder',
    defaultMessage: 'Search for anything',
    description: 'Placeholder for the home page AI query input in the Discovery state (State A)',
  },
  aiQueryPlaceholderAsk: {
    id: 'dashboard.aiQueryBar.placeholderAsk',
    defaultMessage: 'Ask anything',
    description: 'Placeholder for the home page AI query input in the Pre-Engagement state (State B)',
  },
  aiQuerySendLabel: {
    id: 'dashboard.aiQueryBar.sendLabel',
    defaultMessage: 'Send to AI tutor',
    description: 'Screen-reader label for the send button on the home page AI query input',
  },
});

export default messages;
